import { format, parseISO } from 'date-fns';
import { fr } from 'date-fns/locale';

const LOCALE = 'fr-CH';

const chf0 = new Intl.NumberFormat(LOCALE, {
  style: 'currency',
  currency: 'CHF',
  minimumFractionDigits: 0,
  maximumFractionDigits: 0,
});
const chf2 = new Intl.NumberFormat(LOCALE, {
  style: 'currency',
  currency: 'CHF',
  minimumFractionDigits: 2,
  maximumFractionDigits: 2,
});

export function formatChf(amount: number | string | null | undefined, opts: { decimals?: 0 | 2 } = {}) {
  if (amount === null || amount === undefined) return '—';
  const n = typeof amount === 'string' ? Number(amount) : amount;
  if (Number.isNaN(n)) return '—';
  return (opts.decimals === 0 ? chf0 : chf2).format(n);
}

export function formatAmount(amount: number | string, currency: string) {
  const n = typeof amount === 'string' ? Number(amount) : amount;
  return new Intl.NumberFormat(LOCALE, {
    style: 'currency',
    currency,
    minimumFractionDigits: 2,
  }).format(n);
}

export function formatDateShort(d: string | Date) {
  const date = typeof d === 'string' ? parseISO(d) : d;
  return format(date, 'dd.MM.yyyy', { locale: fr });
}

export function formatDateLong(d: string | Date) {
  const date = typeof d === 'string' ? parseISO(d) : d;
  return format(date, 'd MMMM yyyy', { locale: fr });
}

export function formatPct(p: number, decimals = 0) {
  return new Intl.NumberFormat(LOCALE, { style: 'percent', maximumFractionDigits: decimals }).format(p);
}
